import React from 'react'
import { GiWorld } from "react-icons/gi";
import puzzle from '../../assets/images/puzzle.svg'
import { useNavigate } from 'react-router-dom';

const HomeOurTeam = () => {
    const navigation = useNavigate()

    const handleLinkedInClick = () => {
        window.open('https://www.linkedin.com/company/liberyus/', '_blank');
    };

    return (
        <div className='home-our-team'>
            <div className='left'>
                <div><h3>JOIN OUR TEAM</h3></div>
                <div><img src={puzzle} alt='' /></div>
            </div>
            <div className='right'>
                <div><span className='text'>We are on the lookout for daring and creative minds to be the driving force behind the expansion of our ecosystem. See open positions, submit your application or send us your resume.</span></div>
                <div className='join-btn' onClick={(handleLinkedInClick) }>
                    <GiWorld />
                    <span>Join Our Team</span>
                </div>
            </div>
        </div>
    )
}

export default HomeOurTeam
